import React from 'react';
import GenericJsonReport from './GenericJsonReport';
import { get_zydus_batch_report_json } from '@/utils/api';

/**
 * MasterLot Detailed report (Zydus) — data-driven. Renders from the structured
 * JSON of get_zydus_batch_report_json in the backend report design.
 */
const MasterLotReport = ({ batchNumber }) => (
  <GenericJsonReport
    fetcher={get_zydus_batch_report_json}
    batchNumber={batchNumber}
    title="MasterLot Detailed Report"
  />
);

export default MasterLotReport;
